import { Typography } from '@mui/material';
import React from 'react';

import { Children } from '../../../shared/types';

const CardNoContentHeading = ({ children }: Children) => {
    return <Typography variant="body1">{children}</Typography>;
};

export default CardNoContentHeading;
